import { motion } from "framer-motion";
import { Star } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export const Testimonials = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <section className="py-24 md:py-32 border-t border-hairline" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ duration: 1.2, ease: EASE }}
          className="font-mono text-[11px] uppercase tracking-[0.2em] text-mist block mb-5"
        >
          07 — What teams say
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, ease: EASE }}
          className="font-medium tracking-tight leading-tight text-3xl md:text-4xl lg:text-5xl mb-16 md:mb-20 text-ink max-w-2xl"
        >
          Real words from people who ran their files.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((t, i) => (
            <motion.figure
              key={`${t.name}-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.1 }}
              className="bg-white border border-edge rounded-sm p-6 md:p-7 flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              {t.rating ? (
                <span className="flex gap-1 mb-4" aria-label={`${t.rating} out of 5`}>
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="w-3.5 h-3.5 text-bronze fill-bronze" strokeWidth={1.5} />
                  ))}
                </span>
              ) : null}
              <blockquote className="text-base text-ink leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</blockquote>
              <figcaption className="mt-6 pt-4 border-t border-hairline">
                <span className="block font-mono text-[11px] uppercase tracking-[0.15em] text-ink">{t.name}</span>
                {t.role ? <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-mist mt-1">{t.role}</span> : null}
              </figcaption>
            </motion.figure>
          ))}
        </div>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist mt-6" data-testid="testimonials-note">
          Shared after real runs — every quote is reviewed before it appears here
        </p>
      </div>
    </section>
  );
};
